import React from 'react';
import { LicenseServerMode } from '../api/models/server';


export const ModeContext = React.createContext<LicenseServerMode>(LicenseServerMode.NotSet);
